// TODO: migrate to @raydiant/raydial icon
import { SVGProps } from 'react';

interface PlaylistRemoveIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

const PlaylistRemoveIcon = ({
  size = 17,
  ...props
}: PlaylistRemoveIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 17v2H8v-2h12zm0-4v2H8v-2h12zM6 2v3c4.284 0 7.87 2.994 8.778 7.003h-.869c-.466 0-.892-.002-1.2-.005C11.844 9.11 9.163 7 6 7v3L2 6l4-4zm14 7v2h-4V9h4z"
      fill="currentColor"
    />
  </svg>
);

export default PlaylistRemoveIcon;
